import { buildModelManager } from "../builder.js";
const DefaultAccountingConnectionSelection = {
  __typename: true,
  id: true,
  accessTokenEnc: true,
  accessTokenExpiresAt: true,
  backfillCursor: true,
  backfillStatus: true,
  chartOfAccountsCache: true,
  consecutiveAuthFailures: true,
  consecutiveCycleFailures: true,
  createdAt: true,
  deletedAt: true,
  externalOrgCountry: true,
  externalOrgCurrency: true,
  externalOrgFeatures: true,
  externalOrgFiscalYearEnd: true,
  externalOrgId: true,
  externalOrgName: true,
  isPlatformOwner: true,
  isSandbox: true,
  lastErrorAt: true,
  lastErrorMessage: true,
  lastPollDurationMs: true,
  lastSyncAt: true,
  lineCategoryMappings: true,
  profileId: true,
  provider: true,
  reconcileCursor: true,
  refreshTokenEnc: true,
  refreshTokenExpiresAt: true,
  scopes: true,
  status: true,
  taxRatesCache: true,
  taxRegistered: true,
  updatedAt: true
};
const modelApiIdentifier = "accountingConnection";
const pluralModelApiIdentifier = "accountingConnections";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAccountingConnectionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAccountingConnectionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAccountingConnectionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAccountingConnectionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAccountingConnectionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAccountingConnectionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAccountingConnectionSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "accountingConnectionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AccountingConnectionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAccountingConnectionSelection,
  operations
);
export {
  AccountingConnectionManager,
  DefaultAccountingConnectionSelection
};
//# sourceMappingURL=AccountingConnection.js.map
